var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "9", md: "3" } },
        [
          _c("app-ledger-account-autocomplete", {
            ref: "code",
            attrs: {
              value: _vm.inputs.code,
              "has-error": !_vm.ledgerAccountValid,
              fancy: "",
              label: _vm.$ct("code"),
            },
            on: {
              input: function ($event) {
                return _vm.onCode($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "9", md: "2" } },
        [
          _c("w-input-number", {
            ref: "debet",
            attrs: { fancy: "", decimals: 2, label: _vm.$ct("debet") },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focus("credit")
              },
            },
            model: {
              value: _vm.inputs.debet,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "debet", $$v)
              },
              expression: "inputs.debet",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "3", md: "2" } },
        [
          _c("w-input-number", {
            ref: "credit",
            attrs: { fancy: "", decimals: 2, label: _vm.$ct("credit") },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focus("comment")
              },
            },
            model: {
              value: _vm.inputs.credit,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "credit", $$v)
              },
              expression: "inputs.credit",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "5" } },
        [
          _c(
            "w-row",
            { attrs: { "no-wrap": "" } },
            [
              _c("w-input", {
                ref: "comment",
                staticClass: "mr grow",
                attrs: { fancy: "", label: _vm.$ct("comment") },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.add()
                  },
                },
                model: {
                  value: _vm.inputs.comment,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputs, "comment", $$v)
                  },
                  expression: "inputs.comment",
                },
              }),
              _vm.$wf.isMdUp
                ? _c(
                    "div",
                    { staticClass: "button-wrapper mr" },
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "danger",
                          attrs: { round: "", disabled: !_vm.showRemoveButton },
                          on: {
                            click: function ($event) {
                              return _vm.remove()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "button-wrapper" },
                [
                  _c(
                    "w-button",
                    {
                      attrs: { round: "", disabled: !_vm.isValid },
                      on: {
                        click: function ($event) {
                          return _vm.add()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "check" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }